import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Coffee } from "lucide-react";
import { EpisodeCard, EpisodeModal } from "../components/SectionsB";
import { EPISODES, PLUGIN_CAFE, LOGO } from "../mock";

const AllEpisodesPage = () => {
  const [active, setActive] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#141414]">
      {/* Top bar */}
      <header className="sticky top-0 z-50 bg-[#2b2b2b]/95 backdrop-blur">
        <div className="max-w-6xl mx-auto px-5 h-[68px] flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={LOGO} alt="Davide Lepido" className="h-8 w-auto" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm tracking-wide text-gray-200 hover:text-white transition-colors"
          >
            <ArrowLeft size={18} />
            Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <div className="eyebrow text-xs text-[var(--accent-pink)] font-semibold mb-3">La rubrica</div>
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-white">Plugin Café</h1>
          <div className="w-16 h-[3px] bg-[var(--accent-pink)] mx-auto mt-5" />
          <p className="flex items-center justify-center gap-3 text-gray-300 max-w-2xl mx-auto text-center font-light text-lg mt-8">
            <Coffee className="text-[var(--accent-pink)] shrink-0" size={24} />
            <span>{PLUGIN_CAFE.intro}</span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {EPISODES.slice().reverse().map((e, i) => (
            <EpisodeCard key={e.ep} e={e} onSelect={setActive} delay={(i % 4) * 50} />
          ))}
        </div>
      </main>

      <EpisodeModal active={active} onClose={() => setActive(null)} />
    </div>
  );
};

export default AllEpisodesPage;
